export const getCustomLogo = (orgName) => {
  switch (orgName) {
    case 'Summit2Sea Consulting LLC':
      return '/images/logos/summit-2-sea-consulting.png'
    default:
      return null
  }
}
